import React, { memo } from 'react'
import moment from 'moment'
import ControlledDatePicker from 'transfix-form/components/ControlledDatePicker'
import { FormIf } from 'transfix-form/components/FormIf'
import Box from 'transfix-ui/core/Box'
import Grid from 'transfix-ui/core/Grid'
import Typography from 'transfix-ui/core/Typography'
import { MaterialUiPickersDate } from 'transfix-ui/core/pickers'
import FORMATS from 'constants/datetime'
import { TEST_IDS } from '../../constants'
import { useSavedLaneFormContext } from '../../context/SavedLaneFormContext'
import { getErrorMessage } from '../../schema'
import { IDateTypes } from '../../types'
import ControlledCheckboxDays from './ControlledCheckboxDays'

/**
 * @example getFormattedDate(date) // '2022-10-22'
 */
const getFormattedDate = (date: MaterialUiPickersDate) => moment(date).format(FORMATS.yearFirst)

export interface IDateFormSectionProps {}

const DateFormSection = memo<IDateFormSectionProps>(() => {
  /**
   * Form Context
   */
  const { control, errors } = useSavedLaneFormContext()
  const daysOfWeekErrors = getErrorMessage(errors, 'daysOfWeek')
  const specificDateErrors = getErrorMessage(errors, 'date')
  return (
    <div>
      <FormIf control={control} name='dateType' when={IDateTypes.daysOfWeek}>
        <Box mb={3}>
          <Grid container data-test={TEST_IDS.daysOfWeekFormSection}>
            <Grid item xs={12}>
              <Box mb={1.5}>
                <Typography variant='subtitle1'>Days of Week</Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <ControlledCheckboxDays
                control={control}
                name='daysOfWeek'
                errors={daysOfWeekErrors}
              />
            </Grid>
          </Grid>
        </Box>
      </FormIf>
      <FormIf control={control} name='dateType' when={IDateTypes.specificDates}>
        <Box mb={3}>
          <Grid container data-test={TEST_IDS.specificDateFormSection}>
            <Grid item xs={12}>
              <Box mb={1.5}>
                <Typography variant='subtitle1'>Specific Date</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <ControlledDatePicker
                control={control}
                name='date'
                transform={getFormattedDate}
                DatePickerProps={{
                  dataTest: TEST_IDS.datePicker,
                  placeholder: 'Select a date',
                  error: !!specificDateErrors,
                  validationMessage: specificDateErrors,
                  required: true,
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </FormIf>
    </div>
  )
})

export default DateFormSection
